import React, { FormEvent, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { OtpArray } from '../../types'
import Timer from '../elements/Timer'
import OneTimePassword from '../globals/Otp'
import { TriggerToast } from '../globals/Toaster'
import useLogout from '../hooks/auth/useLogout'
import useVerifyOtp from '../hooks/auth/useVerifyOtp'
import { useAuthService } from '../hooks/services/useAuthService'
import IconFont from '../elements/IconFont'
import { EmailIcon } from '../Icons'

const EmailVerification: React.FC = (): React.ReactElement => {

  const logout = useLogout()

  const location = useLocation();
  const verifyOtp = useVerifyOtp()
  const authService = useAuthService()

  const userUnverified = location.state?.unverified || null;
  const stringEmail = String(location.state?.email);

  const [seconds, setSeconds] = useState(60000);
  const [oneTimePassword, setOneTimePassword] = useState<OtpArray>(['', '', '', ''])
  const [timerActive, setTimerActive] = useState(true);
  const [timerClass, setTimerClass] = useState("block")
  const [resendClass, setResendClass] = useState("hidden")

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    const joinedOtp = String(oneTimePassword.join(""))
    verifyOtp({ otp: joinedOtp, email: stringEmail })
  }

  const showTimer = () => {
    setTimerClass("block")
    setResendClass("hidden")
  }

  const hideTimer = () => {
    setTimerClass("hidden")
    setResendClass("block")
  }

  const handleResend = () => {
    authService.resendOtp(stringEmail).then((response) => {
      TriggerToast(response?.message, undefined, 'success')
      setTimerActive(true)
      setSeconds(60000)
    })
  }

  const useDifferentEmail = () => {
    logout('/register');
  }

  useEffect(() => {
    if (timerActive) {
      showTimer()
    } else {
      hideTimer()
    }
    // resend the OTP if the user comes from login but is unverified
    if (userUnverified === true) {
      authService.resendOtp(stringEmail).then(() => {
        TriggerToast("User unverified, an OTP is resent to your email", undefined, 'success')
      })
    }
  }, [timerActive])

  return (
    <div className="h-full mx-auto mt-[16px] block">
      <div className="text-accent text-center font-semibold text-sm mt-10 mb-5">
        <button onClick={useDifferentEmail} className="btn-ghost gap-[4px]"><IconFont name="arrow-right" size={16} className="text-inherit" /> Use Different Email</button>
      </div>
      <form method="POST" className="flex items-center justify-center flex-col pt-[24px]" onSubmit={handleSubmit}>
        <div className="ui-panel-icon p-2">
          <EmailIcon />
        </div>
        <h2 className="text-[24px] font-semibold mt-[32px] text-center">Verify Your Account</h2>
        <p className="mt-[8px] text-md text-center mb-[32px]">Please input the one-time password to verify your account. <strong>If not verified in 7 days, your account will be deleted.</strong></p>
        <OneTimePassword oneTimePassword={oneTimePassword} setOneTimePassword={setOneTimePassword} />
        <button type="submit" className="btn-primary">Submit</button>
        <div className="mt-[16px] inline-flex gap-[4px] text-md text-center">
          <div className={timerClass}>
            <span>You can request new OTP in </span>
            <Timer seconds={seconds} setSeconds={setSeconds} initialMiliseconds={60000} timerActive={timerActive} setTimerActive={setTimerActive} />
          </div>
          <div className={resendClass}>
            <span>Can't find email? </span>
            <button type="button" onClick={() => { handleResend() }} className="type-link font-semibold p-0 m-0 inline-block">
              Resend OTP
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EmailVerification;
